export default __webpack_public_path__ + "static/media/login_bg_vhq.4108f5ee.png";